<script>
export default {
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {
    hours: function () {
      return parseInt(this.component.minutes / 60);
    },
    minutes: function () {
      return this.component.minutes % 60;
    },
    minutesOnly: function () {
      return this.hours == 0;
    },
    warning: function () {
      return this.component.minutes < 30;
    },
    danger: function () {
      return this.component.minutes == 0;
    },
  },
};
</script>

<template>
  <div class="home24-timeleft home24-box" :class="{ warning, danger }">
    <f-icon icon="fa6-clock"></f-icon>
    <div class="home24-timeleft-time">
      <div class="left">{{ minutesOnly ? minutes : hours }}</div>
      <div class="right">
        <div class="unit">
          {{ minutesOnly ? $vtc("minute | minutes", minutes) : $vtc("hour | hours", hours) }}
        </div>
        <div class="minutes" v-if="!minutesOnly && minutes > 0">
          <span class="value">{{ minutes }}</span> {{ $vtc("minute | minutes", minutes) }}
        </div>
      </div>
    </div>
    <f-button
      :disabled="!component.hour_price || component.expired"
      :href="(component.hour_price && !component.expired)?'#/extra_hours':''"
      type="primary"
      >{{ $vt("Buy extra hours") }} <f-icon icon="fa6-plus"></f-icon
    ></f-button>
  </div>
</template>

<style lang="scss">
.home24-timeleft {
  display: flex;
  gap: 8px;
  align-items: center;

  &.warning {
    .home24-timeleft-time {
      .left {
        color: var(--notice);
      }
    }
  }

  &.danger {
    .home24-timeleft-time {
      .left {
        color: var(--negative);
      }
    }
  }

  > .f-icon {
    color: var(--primary);
    font-size: 40px;
  }

  .home24-timeleft-time {
    display: flex;
    align-items: center;
    gap: 8px;
    .left {
      text-align: center;
      font-family: Lato;
      font-size: 48px;
      font-style: normal;
      font-weight: 800;
      line-height: 100%; /* 48px */
      color: var(--primary);
    }
    .right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .unit {
        color: var(--white-a75);
        text-align: center;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        letter-spacing: 0.32px;
        text-transform: uppercase;
      }
      .minutes {
        .value {
          color: var(--primary);
        }
        color: var(--white-a75);
        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 800;
        line-height: 125%; /* 17.5px */
      }
    }
  }

  > .f-button {
    font-weight: 400;
    padding: 8px 8px 8px 16px;
    margin-left: auto;
    .f-icon {
      font-size: 20px;
    }
  }
}
</style>